var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Divider from '@mui/material/Divider';
import Button from './geebee/Button';
import LoadingButton from './mui/LoadingButton';
var SectionCard = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.title, title = _c === void 0 ? '' : _c, children = _a.children, _d = _a.enableEdit, enableEdit = _d === void 0 ? false : _d, onSubmit = _a.onSubmit, _e = _a.contentContainerClassName, contentContainerClassName = _e === void 0 ? '' : _e, _f = _a.loading, loading = _f === void 0 ? false : _f, _g = _a.controlled, controlled = _g === void 0 ? false : _g, _h = _a.externalEditable, externalEditable = _h === void 0 ? false : _h, onChange = _a.onChange, renderCta = _a.renderCta, _j = _a.saveButtonProps, saveButtonProps = _j === void 0 ? { variant: 'contained', showIcons: false } : _j, _k = _a.editButtonProps, editButtonProps = _k === void 0 ? { variant: 'outlined', showIcons: false } : _k;
    var _l = __read(useState(controlled ? externalEditable : false), 2), editable = _l[0], setEditable = _l[1];
    var childrenWithProps = React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            var newProps = {
                editable: controlled ? externalEditable : editable,
                onSave: function () { }
            };
            return React.cloneElement(child, newProps);
        }
        return child;
    });
    var toggleEdit = function () {
        controlled ? onChange === null || onChange === void 0 ? void 0 : onChange(!externalEditable) : setEditable(function (edit) { return !edit; });
    };
    var handleSubmit = function () {
        toggleEdit();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    };
    return (React.createElement("div", { className: "lfc-bg-white lfc-w-full lfc-shadow-min lfc-rounded-md ".concat(className) },
        React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-between lfc-p-3" },
            React.createElement("p", { className: "lfc-text-lg lfc-font-medium" }, title),
            loading && React.createElement(LoadingButton, null),
            !loading &&
                (enableEdit ? ((controlled ? externalEditable : editable) ? (React.createElement(Button, { onClick: handleSubmit },
                    saveButtonProps.showIcons && React.createElement(SaveIcon, { fontSize: "small", sx: { marginRight: '0.5rem' } }),
                    "Save")) : (React.createElement(Button, { onClick: toggleEdit, variant: "outlined" },
                    saveButtonProps.showIcons && React.createElement(EditIcon, { fontSize: "small", sx: { marginRight: '0.5rem' } }),
                    "Edit"))) : null),
            renderCta),
        React.createElement(Divider, null),
        React.createElement("div", { className: contentContainerClassName }, childrenWithProps)));
};
export default SectionCard;
//# sourceMappingURL=SectionCard.js.map